import { observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Alert, Superpixel } from '@feathr/components';
import Page from '@feathr/extender/App/Page';
import { useAccount } from '@feathr/extender/state';

import * as styles from './SuperPixelPage.css';

function SuperPixelPage(): JSX.Element {
  const account = useAccount();
  const { t } = useTranslation();

  const params = new URLSearchParams(window.location.search);

  return (
    <Page title={t('Your Super Pixel')}>
      {params.get('nodata') && (
        <Alert
          className={styles.alert}
          description={t(
            "This is where you'll find all the analytics data that you collect through the Super Pixel, and where you'll be able to build actionable audience groups to use in your campaigns and goals. If you haven't already, please follow the instructions below to install the super pixel on your website(s) and start collecting information about your digital audience.",
          )}
          title={t('Welcome to your Feathr database')}
          type={'info'}
        />
      )}
      <Superpixel
        hasServices={account.hasServices}
        id={account.id}
        isActive={account.hasActiveSuperpixel}
      />
    </Page>
  );
}

export default observer(SuperPixelPage);
